import React, { useState, MouseEvent } from 'react';
import { Button, Menu, MenuItem, Box } from '@mui/material';
import { TSubmitRecord } from '../types';
import {
  documentActionsContainerStyle,
  menuBackdropStyle,
  menuPaperStyle,
  menuLinkStyle,
} from '../styles.ts';

interface DocumentActionsProps {
  record: TSubmitRecord;
  handleDocumentClick: (id: string, documentId: string) => void;
}

export const DocumentActions: React.FC<DocumentActionsProps> = ({
  record,
  handleDocumentClick,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (event?: MouseEvent) => {
    if (event) event.stopPropagation();
    setAnchorEl(null);
  };

  const onNewPageClick = (e: MouseEvent) => {
    handleClose(e);
    if (record.applicationDocumentId) {
      handleDocumentClick(record.id, record.applicationDocumentId);
    }
  };

  if (!record.applicationDocumentId && !record.earchiveLink) {
    return null;
  }

  return (
    <Box sx={documentActionsContainerStyle}>
      <Button
        variant="contained"
        size="small"
        onClick={handleClick}
        aria-controls={open ? 'document-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        Документ
      </Button>
      <Menu
        id="document-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transitionDuration={0}
        slotProps={{
          backdrop: {
            invisible: true,
            sx: menuBackdropStyle,
          },
          paper: {
            elevation: 3,
            sx: menuPaperStyle,
          },
        }}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {record.applicationDocumentId && (
          <MenuItem onClick={onNewPageClick}>Переглянути на новій сторінці</MenuItem>
        )}

        {record.earchiveLink && (
          <MenuItem
            onClick={handleClose}
            component="a"
            href={record.earchiveLink}
            target="_blank"
            rel="noopener noreferrer"
            sx={menuLinkStyle}
          >
            Переглянути в ЄАрхів
          </MenuItem>
        )}
      </Menu>
    </Box>
  );
};
